import request from '@/utils/request'; //删除三方登录

export function delethreeLogin(data) {
  return request({
    url: '/pay/del_login_type',
    method: 'get',
    params: data
  });
}